import { render, staticRenderFns } from "./configuration-tab.vue?vue&type=template&id=6f621694"
import script from "./configuration-tab.vue?vue&type=script&lang=js"
export * from "./configuration-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports